import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";
import { isTreesloMediumDateDisplay } from "../helpers/material-date-formats.helper";

/**
 * Material date adapter that keeps form values as native Date objects while
 * displaying calendar dates with longDate + UTC (full month name, same timezone rules as localizedDate).
 */
@Injectable()
export class TreesloNativeDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: object): string {
    if (!this.isValid(date) || !isTreesloMediumDateDisplay(displayFormat)) {
      return super.format(date, displayFormat);
    }

    const calendarUtc = new Date(
      Date.UTC(this.getYear(date), this.getMonth(date), this.getDate(date)),
    );

    return formatDate(calendarUtc, "longDate", this.locale, "UTC");
  }
}
